import type { RefObject } from 'react';
import type { FlatList } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import type { ChatMessageItemFragment } from '@/components/Chat/ChatMessageItem.utils';
import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import type { FragmentOf } from '@/gql/graphql';

type ChatScrollDownButtonProps = {
  listRef: RefObject<FlatList<
    FragmentOf<typeof ChatMessageItemFragment>
  > | null>;
  unseenMessageCount: number;
};

export default function ChatScrollDownButton({
  listRef,
  unseenMessageCount = 0,
}: ChatScrollDownButtonProps) {
  const jumpToLatestMessage = () => {
    listRef.current?.scrollToOffset({ offset: 0, animated: true });
  };

  return (
    <Box style={style.container}>
      {unseenMessageCount > 0 ? (
        <Box style={style.unseenMessageCount}>
          <Text variant="white" size="md">
            {unseenMessageCount}
          </Text>
        </Box>
      ) : null}

      <Button
        iconOnly
        variant="secondary"
        appearance="outline"
        onPress={jumpToLatestMessage}
        style={style.button}
      >
        <Icon name="arrow-down-outline" />
      </Button>
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    position: 'absolute',
    bottom: theme.space('xl'),
    right: theme.space('xl'),
    gap: theme.space('md'),
    alignItems: 'center',
  },
  unseenMessageCount: {
    backgroundColor: theme.colors.info,
    width: theme.size(8),
    height: theme.size(8),
    borderRadius: theme.borderRadius.full,
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    borderRadius: theme.borderRadius.full,
    width: theme.size(10),
    height: theme.size(10),
    padding: theme.space('md'),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
